import { render, staticRenderFns } from "./UserLocationsMultiNew.vue?vue&type=template&id=53011661"
import script from "./UserLocationsMultiNew.vue?vue&type=script&lang=ts"
export * from "./UserLocationsMultiNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53011661')) {
      api.createRecord('53011661', component.options)
    } else {
      api.reload('53011661', component.options)
    }
    module.hot.accept("./UserLocationsMultiNew.vue?vue&type=template&id=53011661", function () {
      api.rerender('53011661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/UserLocationsMultiNew.vue"
export default component.exports